"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const DEFAULT_CURRENCY_1 = __importDefault(require("../../../constants/date/DEFAULT_CURRENCY"));
const formatPriceValue_1 = __importDefault(require("../../utils/common/formatPriceValue"));
const formatPriceWithoutDecimals_1 = __importDefault(require("../../utils/common/formatPriceWithoutDecimals"));
const getSoldDays_1 = __importDefault(require("../../utils/fleetquote/getSoldDays"));
const getSoldHours_1 = __importDefault(require("../../utils/fleetquote/getSoldHours"));
/**
 * Returns formatted fleet price info
 * @param {FleetPriceType} fleetPrice
 * @returns {FleetPriceFactoryType}
 */
function fleetQuoteFactory(fleetQuote, returnOriginalPrice = false) {
    const currency = (0, get_1.default)(fleetQuote, 'currency', DEFAULT_CURRENCY_1.default);
    const pricePerDay = (0, get_1.default)(fleetQuote, 'pricePerDay');
    const sortPrice = Number(Number(pricePerDay).toFixed(0)); // to-do: will do rounding - product?
    const formattedPrice = (0, formatPriceWithoutDecimals_1.default)(`${pricePerDay}`);
    const displayPrice = `${formattedPrice} ${currency}`;
    const hasDiscount = !!Number((0, get_1.default)(fleetQuote, 'priceDetails.discount', ''));
    const hasDropOffSum = !!Number((0, get_1.default)(fleetQuote, 'priceDetails.dropOffSum', ''));
    const creditCardRequired = (0, get_1.default)(fleetQuote, 'creditCardRequired', false);
    const allDiscountDetails = (0, get_1.default)(fleetQuote, 'priceDetails.allDiscountDetails', {});
    const onlineDiscountDetails = (0, get_1.default)(fleetQuote, 'priceDetails.onlineDiscountDetails');
    const hasAllDiscount = !(0, isEmpty_1.default)(allDiscountDetails);
    const hasOnlineDiscount = !(0, isEmpty_1.default)(onlineDiscountDetails);
    const soldDays = (0, getSoldDays_1.default)(`${(0, get_1.default)(fleetQuote, 'soldDays', 0)}`);
    const dailyKmsAllowance = (0, get_1.default)(fleetQuote, 'dailyKmsAllowance', 0);
    const finalPrice = Number((0, get_1.default)(fleetQuote, 'finalPrice'));
    const rewardsOptions = (0, get_1.default)(fleetQuote, 'rewardOptions', []);
    const isCorporate = (0, get_1.default)(fleetQuote, 'priceDetails.promotionDetails.corporate', false);
    const returnData = {
        available: (0, get_1.default)(fleetQuote, 'available', false),
        currency,
        extCarGroup: (0, get_1.default)(fleetQuote, 'extCarGroup', ''),
        expiry: (0, get_1.default)(fleetQuote, 'expiry', Date.now() / 1000),
        finalPrice: (0, formatPriceValue_1.default)(finalPrice, currency),
        groupId: (0, get_1.default)(fleetQuote, 'groupId', -1),
        soldDays,
        soldHours: (0, getSoldHours_1.default)(`${(0, get_1.default)(fleetQuote, 'soldDays', 0)}`),
        vatPercentage: `${Number((0, get_1.default)(fleetQuote, 'vatPercentage')).toFixed(0)}%`,
        vat: (0, formatPriceValue_1.default)((0, get_1.default)(fleetQuote, 'priceDetails.vat'), currency),
        pricePerDay: (0, get_1.default)(fleetQuote, 'pricePerDay'),
        rental: (0, formatPriceValue_1.default)((0, get_1.default)(fleetQuote, 'priceDetails.rentalSum'), currency),
        extra: (0, formatPriceValue_1.default)((0, get_1.default)(fleetQuote, 'priceDetails.extraSum'), currency),
        cdw: (0, formatPriceValue_1.default)((0, get_1.default)(fleetQuote, 'priceDetails.cdw'), currency),
        cdwPerDay: (0, get_1.default)(fleetQuote, 'cdwPerDay'),
        discount: (0, formatPriceValue_1.default)((0, get_1.default)(fleetQuote, 'priceDetails.discount'), currency),
        hasDiscount,
        dropOffSum: (0, formatPriceValue_1.default)((0, get_1.default)(fleetQuote, 'priceDetails.dropOffSum'), currency),
        hasDropOffSum,
        dropOffCharge: (0, formatPriceValue_1.default)((0, get_1.default)(fleetQuote, 'priceDetails.dropOffCharge'), currency),
        quoteId: (0, get_1.default)(fleetQuote, 'quoteId', ''),
        displayPrice,
        sortPrice,
        dailyKmsAllowance,
        allowanceKms: Math.trunc(dailyKmsAllowance * Number(soldDays)),
        extraKmsCharge: (0, get_1.default)(fleetQuote, 'extraKmsCharge'),
        isCreditCardRequired: creditCardRequired,
        rewardsOptions,
        isCorporate,
    };
    let discountObj = {};
    // find out which discount to pick up
    if (hasAllDiscount) {
        discountObj = Object.assign({}, allDiscountDetails);
    }
    // online discount takes priority
    if (hasOnlineDiscount) {
        discountObj = Object.assign({}, onlineDiscountDetails);
    }
    if ((hasAllDiscount || hasOnlineDiscount) && !returnOriginalPrice) {
        const hasDiscount = !!Number((0, get_1.default)(discountObj, 'discount', ''));
        const rewardsOptions = (0, get_1.default)(discountObj, 'rewardOptions');
        const finalPrice = (0, get_1.default)(discountObj, 'finalPrice');
        returnData.finalPrice = (0, formatPriceValue_1.default)(finalPrice, currency);
        returnData.vat = (0, formatPriceValue_1.default)((0, get_1.default)(discountObj, 'vat'), currency);
        returnData.hasDiscount = hasDiscount;
        returnData.discount = (0, formatPriceValue_1.default)((0, get_1.default)(discountObj, 'discount'), currency);
        returnData.rewardsOptions = rewardsOptions;
    }
    return returnData;
}
exports.default = fleetQuoteFactory;
